<template>
  <main-component />
</template>

<script>
import MainComponent from '@/components/Settings/DataInit/index'

export default {
  components: {
    MainComponent
  },

  data () {
    return {
      modelName: 'settings/dataInit'
    }
  },

  async created () {
    this.$store.commit(`settings/setAttr`, {
      name: 'menuSelected',
      value: 'data-init'
    })

    await this.$store.dispatch(`${this.modelName}/get`)
    this.$store.dispatch(`${this.modelName}/set`)
  }
}
</script>
